<section class="breadcrumbs">
  <ng-container *ngFor="let breadcrumb of breadcrumbs; let last = last; trackBy: trackBy">
    <a [href]="breadcrumb.url" [translate]="breadcrumb.key" class="a-breadcrumb" [class.active]="breadcrumb.isActive"
    [routerLink]=[breadcrumb.url] [queryParams]="breadcrumb.queryParams"></a>
    <span class="divider" *ngIf="!last">|</span>
  </ng-container>
</section>
